import axios from '../axios'
import Auth from './auth'
import Campaign from './campaign'
import Data from './data'
import Game from './game'
import GameData from './gameData'
import GameLobby from './gameLobby'
import GameOwner from './gameOwner'
import GameTemplate from './gameTemplate'
import Guest from './guest'
import Product from './product'
import Team from './team'
import User from './user'
import UserAccount from './userAccount'

export default {
  auth: Auth(axios),
  campaign: Campaign(axios),
  data: Data(axios),
  game: Game(axios),
  gameData: GameData(axios),
  gameLobby: GameLobby(axios),
  gameOwner: GameOwner(axios),
  gameTemplate: GameTemplate(axios),
  guest: Guest(axios),
  product: Product(axios),
  team: Team(axios),
  user: User(axios),
  userAccount: UserAccount(axios),
}
